import type { estypes } from '@elastic/elasticsearch'

export const superGithubMetadataMapping = {
  number: {
    type: 'keyword',
    index: false,
  },
  owner: {
    type: 'keyword',
    index: false,
  },
  repo: {
    type: 'keyword',
    index: false,
  },
  state: {
    type: 'keyword',
    index: false,
  },
  closedAt: {
    type: 'date',
    index: false,
  },
  mergedAt: {
    type: 'date',
    index: false,
  },
  assignees: {
    type: 'keyword',
    index: false,
  },
  reviewers: {
    type: 'keyword',
    index: false,
  },
  labels: {
    type: 'keyword',
    index: false,
  },
  milestone: {
    type: 'keyword',
    index: false,
  },
  draft: {
    type: 'boolean',
    index: false,
  },
  locked: {
    type: 'boolean',
    index: false,
  },
  closedBy: {
    type: 'keyword',
    index: false,
  },
  mergedBy: {
    type: 'keyword',
    index: false,
  },
} satisfies Record<string, estypes.MappingProperty>
